import React from "react";
import {useIntl} from "react-intl";
import {TimestampDisplay} from "@/library/display/timestamp_display.jsx";

import {jobStatusMessage} from "./job_status_message.js";
import {formatTimestamp} from "@/library/format/format_timestamp.js";


export function JobQueueDisplay(props) {
  const job = props.job;
  const intl = useIntl();

  let className = "job-queue-display";
  let message;
  if (job.exit === "error") {
    message = intl.formatMessage(
      {id: "jobs.job.error"}
    )
    className += " error";

  } else if (job.queuePosition > 0) {
    if (job.estimatedStartAt) {
      const eta = formatTimestamp(job.estimatedStartAt);
      message = intl.formatMessage(
        {id: "jobs.job.queuePosition.estimated"},
        {eta, position: job.queuePosition + 1, system: job.controlServer?.identifier}
      )
    } else {
      message = intl.formatMessage(
        {id: "jobs.job.queuePosition"},
        {position: job.queuePosition + 1, system: job.controlServer?.identifier}
      )
    }
    className += " queued";
  } else if (!job.exitedAt) {
    message = intl.formatMessage(
      {id: "jobs.job.waiting." + job.type},
      {system: job.controlServer?.identifier}
    )
    className += " waiting";
  }
  return (
    <span className={className}>
      {message}
    </span>
  );
}
